import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { ROUTE } from '@portal/data-access';
import { tap } from 'rxjs';
import { PortalVerificationStore } from '../store';

export const verifyingGuard = () => {
  const router = inject(Router);
  const store = inject(PortalVerificationStore);

  return store.isVerifying$.pipe(
    tap(isVerifying => {
      return !isVerifying ? router.navigate([ROUTE.VERIFICATION.MAIN]) : true;
    }),
  );
};
